/**
 * Tooltips International Content - The content of Tooltips by id
 */
import React from "react"
import { translateText } from "utils/languageUtils"

export const Tooltips = {
  candidinfo: {
    message: "Store your details so that you can apply faster",
  },
  vantageinfo: {
    message: "Vantage stores your details so that you can apply faster",
  },
  1618: {
    message: `If you completed these exams at a different age, please still complete
    this section and share additional information about your education history
    in your mitigating circumstances.`,
  },
  1416: {
    message: `If you completed these exams at a different age, please still complete
    this section and share additional information about your education history
    in your mitigating circumstances.`,
  },
  timeSpentInCare: {
    messages: [
      `Spending time in local authority care means you will have spent time
      living with foster carers under local authority care, in residential
      care (e.g. a children’s home), looked after at home under a supervision
      order, or officially in kinship care with relatives or friends (e.g. a
      special guardianship order).`,
      `Sometimes you will see the term ‘care leaver’ used. Although this has a
      slightly different meaning, it is occasionally used interchangeably with
      ‘care experience’.`,
    ],
  },
}

export class TooltipsContent extends React.Component {
  render() {
    const { name, translationMap } = this.props
    const result = Tooltips[name]
    if (result) {
      return (
        <div>
          <div className={"tippy-content"}>
            {result.messages ? (
              result.messages.map(message => (
                <p>{translateText(translationMap, message)}</p>
              ))
            ) : (
              <p>{translateText(translationMap, result.message)}</p>
            )}
          </div>
        </div>
      )
    }
  }
}

export default TooltipsContent
